import { useQuery } from '@tanstack/react-query';
import { leavePolicyService } from '@/services/leave/leavePolicyService';
import { leaveQueryKeys } from './queryKeys';
import type { LeavePolicyWithRules } from '@/services/leave/leavePolicyTypes';

export const useLeavePolicies = () => {
  return useQuery({
    queryKey: leaveQueryKeys.policies(),
    queryFn: () => leavePolicyService.getLeavePolicies(),
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};

export const useLeavePolicy = (id: string) => {
  return useQuery({
    queryKey: leaveQueryKeys.policy(id),
    queryFn: () => leavePolicyService.getLeavePolicyById(id),
    enabled: !!id,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};

export const usePolicyAssignments = (policyId: string) => {
  return useQuery({
    queryKey: leaveQueryKeys.policyAssignments(policyId),
    queryFn: () => leavePolicyService.getPolicyAssignments(policyId),
    enabled: !!policyId,
    staleTime: 2 * 60 * 1000, // 2 minutes
  });
};